// useBulkAccess — may this person bulk change / bulk delete at all?
//
// Asks the server (GET /api/issues/bulk-access), which answers with the
// same decision the bulk routes enforce: Settings → Bulk Edit Access /
// Bulk Delete Access groups, site admins always. One answer for every
// page that offers bulk buttons (Zebra Search, Folders) — the browser
// never re-derives the rule, so a button is shown exactly when the
// server would accept the call. Asked on mount (a cheap call; no cache
// that could outlive a sign-out).

import { useEffect, useState } from 'react';
import api from '@app/services/api';

const NONE = { edit: false, delete: false };

export default function useBulkAccess() {
  const [access, setAccess] = useState(NONE);
  useEffect(() => {
    let cancelled = false;
    api.getBulkAccess()
      .then(a => { if (!cancelled) setAccess({ edit: !!a?.edit, delete: !!a?.delete }); })
      .catch(() => { if (!cancelled) setAccess(NONE); });
    return () => { cancelled = true; };
  }, []);
  return access;
}
